/*
 * ハンバーガーメニューの制御
 */

const useTransition = require('../support/transition');

(function ($) {
  $.fn.extend({
    menuController(options) {
      const o = $.extend(
        {
          activeClass: 'is-active',
          openClass: 'is-open',
          menuName: 'oNav',
          menuWrapID: 'js-oNav__inner',
        },
        options,
      );
      return this.each(function () {
        const $this = $(this);
        const $window = $(window);
        const $body = $('body');
        const $pageWrap = $('#pageWrap');
        const $drawerTrigger = $(`#js-${o.menuName}-trigger`);
        const $menuWrap = $this.find(`.${o.menuName}__wrap`);
        const $menuLink = $this.find('.oNav__menu--type01 a[href *= "#"]');
        const $accordionMenu = $this.find(`.${o.menuName}__menu--type01`);
        const $accordionTrigger = $accordionMenu.find('.hasChild');
        let $accordionTriggerButton;
        let $accordionTriggerParent;
        let scrollValue = 0;

        // メディアクエリの値を定義
        const mediaQuery = '(max-width: 960px)';

        // MediaQueryListオブジェクトを生成
        const mql = window.matchMedia(mediaQuery);

        // WAI-ARIAの設定
        const setWaiAria = {
          // 初期化
          init() {
            $menuWrap.attr({
              'aria-hidden': true,
              'aria-expanded': false,
              id: o.menuWrapID,
            });
            $drawerTrigger.attr('aria-controls', o.menuWrapID);
          },

          // メニューが開いた場合
          open() {
            $menuWrap.attr({
              'aria-hidden': false,
              'aria-expanded': true,
            });
            $drawerTrigger.attr({
              'aria-label': 'メニューを閉じる',
            });
          },

          // メニューが閉じた場合
          close() {
            $menuWrap.attr({
              'aria-hidden': true,
              'aria-expanded': false,
            });
            $drawerTrigger.attr({
              'aria-label': 'メニューを開く',
            });
          },
        };

        // ドロワーメニューを閉じる処理
        function menuClose() {
          $drawerTrigger.removeClass(o.openClass);
          $menuWrap.removeClass(o.openClass);

          // スマホ・タブレットの場合は画面スクロール固定を解除
          $body.css({ position: '', top: '', width: '' });
          $(window).scrollTop(scrollValue);

          // メニューの開閉アニメーションが終了したときの処理
          $menuWrap.on(useTransition.end, () => {
            // メニューを開くためのアクティブクラス付いていた場合、開いた後の処理を実行
            if ($menuWrap.hasClass(o.openClass)) {
              setWaiAria.open();
              // メニューを閉じるアニメーションが実行されている場合なので、閉じた後の処理を実行
            } else {
              setWaiAria.close();
              // アコーディオンメニューをすべてて閉じた状態に戻す
              // $accordionTrigger = $accordionMenu.find('.hasChild');
              // $accordionTrigger.removeClass(o.openClass);
              // $accordionTrigger
              //   .find('.js-accordionTrigger')
              //   .removeClass(o.openClass);
              // $accordionTrigger
              //   .find('.' + o.menuName + '__itemWrap')
              //   .removeClass(o.openClass)
              //   .css('height', 0);
            }
          });
          // アコーディオンメニューのクリックイベントの検知を解除
          $accordionMenu
            .find('.js-accordionTrigger')
            .off('click.accordionMenuLv01');

          // escキーの検知を解除
          $window.off('keydown.menuController');

          // メニュー以外の要素のクリックイベントの検知を解除
          $pageWrap.off('click.menuController');
        }

        // ドロワーメニューを開く処理
        function menuOpen() {
          $drawerTrigger.addClass(o.openClass);
          $menuWrap.addClass(o.openClass);

          // 現在のスクロール位置を取得
          scrollValue = $(window).scrollTop();

          // escキーの検知を開始
          $window.on('keydown.menuController', (event) => {
            if (event.keyCode === 27) {
              menuClose();
            }
          });

          // メニュー以外の要素のクリックイベントを検知する
          $pageWrap.on('click.menuController', menuClose);

          // メニュー内の要素がクリックされた場合はイベントバブリングを止める
          $menuWrap.on('click.menuController', (event) => {
            event.stopPropagation();
          });

          // メニューのリンクがクリックされた場合はリンク先をページの先頭にして、ドロワーを閉じる
          $menuLink.one('click.menuLinkController', function (event) {
            event.preventDefault();
            menuLinkController(this);
          });

          // $accordionMenu
          //   .find('.js-accordionTrigger')
          //   .on('click.accordionMenuLv01', function (event) {
          //     event.preventDefault();
          //     $accordionTriggerButton = $(this);
          //     $accordionTriggerParent = $accordionTriggerButton
          //       .parent()
          //       .parent();
          //     if (!$accordionTriggerButton.hasClass(o.openClass)) {
          //       $accordionTriggerButton.addClass(o.openClass);
          //       $accordionTriggerParent.addClass(o.openClass);
          //     } else {
          //       $accordionTriggerButton.removeClass(o.openClass);
          //       $accordionTriggerParent.removeClass(o.openClass);
          //     }
          //     $accordionTrigger = $accordionTriggerParent.find(
          //       '.' + o.menuName + '__itemWrap'
          //     );
          //     if (!$accordionTrigger.hasClass(o.openClass)) {
          //       $accordionTrigger.addClass(o.openClass);
          //       $accordionTrigger.css(
          //         'height',
          //         $accordionTrigger.attr('data-height') + 'px'
          //       );
          //     } else {
          //       $accordionTrigger.removeClass(o.openClass);
          //       $accordionTrigger.css('height', 0);
          //     }
          //   });
        }

        // ドロワーメニューのリンク制御
        function menuLinkController(element) {
          let hash;
          let $target;
          let position;
          const thisPageURL = document.location.href.replace(/(.*)#.*/g, '$1');
          const thisMenuLinkURL = element.href.replace(/(.*)#.*/g, '$1');

          if (thisPageURL === thisMenuLinkURL) {
            // メニューのURLと現在のページが同一ならば、ページ内リンクとして処理を実行
            // $body.css({ position: '', top: '', width: '' });

            hash = $(element)
              .attr('href')
              .replace(/.*(#.*)/g, '$1');
            $target = $(hash === '#' || hash === '' ? 'html' : hash);

            position = $target.offset().top - $('#js-menu').outerHeight() - 20;
            $(window).scrollTop(position);

            $drawerTrigger.removeClass(o.openClass);
            $menuWrap.removeClass(o.openClass);

            // escキーの検知を解除
            $window.off('keydown.menuController');

            // メニュー以外の要素のクリックイベントの検知を解除
            $pageWrap.off('click.menuController');
            $menuLink.off('click.menuLinkController');
          } else {
            // 別のページなので、通常リンクと同じ処理を実行
            document.location.href = element.href;
          }
        }

        // イベントの監視を開始
        function setEventListener() {
          // ドロワーメニューボタンをクリックした時の処理
          $drawerTrigger.on('click', (e) => {
            e.stopPropagation();

            // クリックしたメニューボタンが「Menu（開く）」ならば
            if ($drawerTrigger.hasClass(o.openClass)) {
              menuClose();
              // クリックしたメニューボタンが「Close（閉じる）」ならば
            } else {
              menuOpen();
            }
          });
        }

        // アコーディオンメニューの高さを取得
        function setAccordionHeight() {
          // $accordionTrigger
          //   .find('.' + o.menuName + '__itemWrap')
          //   .each(function () {
          //     $(this).css('height', '');
          //     $(this)
          //       .attr('data-height', $(this).outerHeight())
          //       .css('height', 0);
          //   });
        }

        // ドロワーメニューを表現する要素を生成して追加
        function setButtonElement() {
          $accordionTrigger
            .children('a')
            .prepend(
              '<button class="oNav__button oNav__button--type02 js-accordionTrigger">メニューを開く</button>',
            );
        }

        // 初期化処理
        function init() {
          if (mql.matches) {
            setWaiAria.init();
            // setButtonElement();
            setEventListener();
            // setAccordionHeight();
          }
        }

        // 初期化処理を実行
        init();

        mql.addEventListener('change', init, false);
      });
    },
  });
})(jQuery);
